import {
  KebabHorizontalIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  Checkbox,
  IconButton,
  useConfirm,
} from "@primer/react";
import { useEffect, useState } from "react";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper } from "../../../helpers/toast";
import DataTable from "../../../components/ui/data-table";
import TextTranslated from "../../../components/text";
import Button from "../../../components/ui/button";
import { diemDanhStatusApi } from "../../../api/diemDanhStatusApi";
import { nt_diem_danh_trang_thai } from "../../../models/response/category/nt_diem_danh_trang_thai";
import DiemDanhTrangThaiDetailModal from "./detail-modal";
const DiemDanhTrangThai = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailModalDangKy, setIsShowDetailModalDangKy] = useState(false);

  const [selectedId, setSelectedId] = useState(0);
  const [TrangThais, setTrangThais] = useState<nt_diem_danh_trang_thai[]>([]);
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  const confirm = useConfirm();

  useEffect(() => {
    handleReloadAsync();
  }, []);
  const handleReloadAsync = async () => {
    const res = await diemDanhStatusApi.SelectAll();
    if (res.is_success) {
      setTrangThais(res.data);
    } else {
      NotifyHelper.Error("Có lỗi");
    }
  };

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: "Bạn có chắc chắn muốn xóa trạng thái này?",
        title: "Lưu ý",
        cancelButtonContent: "Không xóa",
        confirmButtonContent: "Xóa trạng thái",
        confirmButtonType: "danger",
      })
    ) {
      const res = await diemDanhStatusApi.Delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReloadAsync();
      } else {
        NotifyHelper.Error("Có lỗi");
      }
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      <DataTable
        height={`${window.innerHeight - 250}px`}
        columns={[
          {
            id: "cmd",
            width: "50px",
            caption: "",
            align: "center",
            cellRender: (data: nt_diem_danh_trang_thai) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          setIsShowModal(true);
                          if (data.id !== undefined) {
                            setSelectedId(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          if (data.id !== undefined) {
                            handeDelete(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            isMainColumn: true,
            dataField: "name",
            width: "auto",
            caption: `Trạng thái`,
            cellRender: (data: nt_diem_danh_trang_thai) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.name}
                </Box>
              );
            },
          },
          {
            isMainColumn: true,
            dataField: "name_en",
            width: "auto",
            caption: `Trạng thái`,
            cellRender: (data: nt_diem_danh_trang_thai) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.name_en}
                </Box>
              );
            },
          },
		  {
            isMainColumn: true,
            dataField: "sort",
            width: "100px",
            caption: `Thứ tự`,
            align: "center"
          },
          {
            isMainColumn: true,
            dataField: "is_default",
            width: "100px",
            caption: `Mặc định`,
            align: "center",
            cellRender: (data: nt_diem_danh_trang_thai) => {
              return (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                   <Checkbox
                  disabled
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                  checked={data.is_default ?? false}
                />
                  </Box>
              );
            },
          },
        ]}
        data={TrangThais}
        title="Trạng thái"
        subTitle={`${translate("Base.Label.TotalCount")}: ${TrangThais.length}`}
        searchEnable
        actionComponent={
          <>
            <Button
              text={translate("Base.Label.Create")}
              leadingVisual={PlusIcon}
              variant="primary"
              size="medium"
              onClick={() => {
                setIsShowModal(true);
                setSelectedId(0);
              }}
            />
          </>
        }
      />
      {isShowModal && (
        <DiemDanhTrangThaiDetailModal
          id={selectedId}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReloadAsync();
            setIsShowModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default DiemDanhTrangThai;
